import styled from 'styled-components';

export const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 20px;

  > button {
    padding: 20px 0;
  }

  button + button {
    margin-top: 24px;
  }
`;
